// extracted by mini-css-extract-plugin
export default {"fab":"ChatFab_fab__Kgs8C","badge":"ChatFab_badge__ZY4u+"};